
export const SET_MARKER_SUBTYPE = 'set/marker_sub-type';
export const SET_IUCN_MEMBERTYPE = 'set/iucn-type';

export const setMarkerSubtype = (data) => {
    return (dispatch,getState) => {
    dispatch( { type: SET_MARKER_SUBTYPE,data } );
    }
};

export const setIucnMembertype = (data) => {
    return (dispatch,getState) => {
    dispatch( { type: SET_IUCN_MEMBERTYPE,data } );
    }
};



// WEBPACK FOOTER //
// ./components/markerPage/actions/setMarkerSubtype.js